<template>
  <v-data-table
    :headers="headers"
    :items="serverList"
    :search="search"
    sort-by="id"
    no-data-text="Нет серверов"
    class="ma-2 elevation-2"
    @click:row="selectRow"
    @dblclick:row="doubleClick"
    single-select
    :loading="isLoading"
    loading-text="Получение данных"
  >
    <template v-slot:top>
      <v-toolbar outlined elevation="0">
        <v-btn icon :loading="isLoading" @click="refreshServers">
          <v-icon> mdi-cached</v-icon>
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-cached</v-icon>
            </span>
          </template>
        </v-btn>
        <v-text-field
          v-model="search"
          label="Поиск (По IP или названию)"
          class="mt-4 ml-2"
        />
        <v-spacer />

        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mb-2"
              large
              color="primary"
              elevation="0"
              v-bind="attrs"
              v-on="on"
              outlined
            >
              ДОБАВИТЬ
              <v-icon> mdi-server-plus </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="justify-center">
              {{ formTitle }}
            </v-card-title>
            <v-form ref="form" v-model="valid" @submit.prevent="save">
              <v-card-text>
                <v-text-field
                  v-model="editedItem.name"
                  label="Название"
                  :rules="nameRules"
                  required
                />

                <v-text-field
                  v-model="editedItem.host"
                  label="WebApi (ip:port)"
                  :rules="hostRules"
                  required
                />

                <v-text-field
                  v-model="editedItem.username"
                  label="Пользователь"
                  :rules="nameRules"
                  required
                />
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="close" type="reset" color="error">
                  ЗАКРЫТЬ
                </v-btn>
                <v-btn :disabled="!valid" color="primary" text type="submit">
                  {{ buttonText }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="600px">
          <v-card>
            <v-card-title class="text-h5"
              >Вы действительно хотите удалить {{ editedItem.name }}?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" outlined text @click="closeDelete"
                >НЕТ</v-btn
              >
              <v-btn color="primary" text @click="deleteItemConfirm">ДА</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }" v-if="!readOnly">
      <v-icon color="primary" small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon color="warning" small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    readOnly: Boolean,
  },
  emits: ["loading-start", "loading-stop", "can-continue"],
  data: () => ({
    isLoading: false,
    search: "",
    valid: false,
    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      name: "",
      host: "",
      username: "",
    },
    defaultItem: {
      id: null,
      name: "",
      host: "",
      username: "",
    },
    nameRules: [(v) => !!v || "Обязательное поле"],
    hostRules: [
      (v) => !!v || "Обязательное поле",
      (v) =>
        /^([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}:[0-9]{1,5})(:[0-9]{1,5})?$/.test(
          v
        ) || "IPv4:PORT",
      (v) => !/^127\.0\.0\.1/.test(v) || "localhost запрещен",
    ],
  }),
  computed: {
    ...mapGetters(["serverList", "msg"]),
    formTitle() {
      return this.editedIndex === -1
        ? "Новый сервер"
        : "Редактирование сервера";
    },
    buttonText() {
      return this.editedIndex === -1 ? "Добавить" : "Сохранить";
    },
    headers() {
      let headers = [
        {
          text: "ID",
          align: "start",
          value: "id",
          filterable: false,
        },
        {
          text: "Название",
          value: "name",
        },
        {
          text: "Хост",
          value: "host",
        },
        {
          text: "Пользователь",
          value: "username",
          filterable: false,
        },
      ];
      if (!this.readOnly)
        headers.push({
          text: "Действия",
          value: "actions",
          sortable: false,
          filterable: false,
        });
      return headers;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelte(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    ...mapActions([
      "requestServers",
      "removeServer",
      "mergeServer",
      "clearServers",
      "selectServer",
    ]),
    editItem(item) {
      this.editedIndex = this.serverList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.serverList.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      this.removeServer(this.editedItem);
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.mergeServer(Object.assign({}, this.editedItem));
      this.close();
    },
    async refreshServers() {
      this.isLoading = true;
      await this.clearServers();
      await this.requestServers();
      this.isLoading = false;
    },
    selectRow(item, row) {
      if (this.readOnly) {
        row.select(true);
        this.selectServer(Object.assign({}, item));
        this.$emit("cant-continue", false);
      }
    },
    doubleClick(_, row) {
      if (!this.readOnly) this.editItem(row.item);
    },
  },
  async mounted() {
    this.$emit("cant-continue", true);
    this.$nextTick(async () => {
      this.isLoading = true;
      if (!this.serverList.length) await this.requestServers();

      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
:deep() tr.v-data-table__selected {
  background: #a5d6a7 !important;
}
</style>